import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { sanitizeReturnPath } from '../services/cognitoAuth';

export default function Login() {
  const { login } = useAuth();
  const location = useLocation();

  // Wherever the user was trying to go before landing here — either handed
  // via router state (`<Navigate to="/login" state={{ from }} />`) or a
  // `?redirect=` query param on a direct/shared link to this page. Both are
  // attacker-influencable (a shared link's query string is copy-pasteable),
  // so sanitize before ever using it (COL-154).
  const params = new URLSearchParams(location.search);
  const returnTo = sanitizeReturnPath(location.state?.from ?? params.get('redirect'), '/');

  return (
    <div className="login-page">
      {/* Brand panel: a tonal emerald field carrying the mark. Deliberately
          holds no copy, so the reading order stays on the sign-in side. */}
      <div className="login-brand" aria-hidden="true">
        <div className="login-brand-mark">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="M21 15l-5-5L5 21" />
          </svg>
        </div>
      </div>

      <main className="login-action">
        <div className="login-action-inner">
          <h1 className="login-title">Collections</h1>
          <p className="login-subtext">
            Save anything from your phone or browser, and find it later by just asking.
          </p>
          <button onClick={() => login(returnTo)} className="btn btn-primary login-submit">
            Sign in to continue
          </button>
        </div>
      </main>
    </div>
  );
}
